import queryString from 'query-string';
import { ANALYSIS_ID } from '../../constant/CookieKeys'
import { getJSON } from '../../api/myaxios'
import { compare_version } from './version'

import { isString, isObject, isArray } from '../typeof'



export function error_event(err, data = '', error_type = "code_error") {
  if (err === 'close_modal') {
    return;
  }
  console.error(err)
  if(window.apmInst){
    window.apmInst.jsError(err, data)
  }
  // setTimeout(() => {
  //   try {
  //     console.error(err)
  //     let err_name = ""
  //     let err_msg = "";
  //     let err_stack = "";
  //     if (isString(err)) {
  //       err_msg = err
  //     } else if (isObject(err)) {
  //       if (err.stack) {
  //         err_stack = err.stack.toString();
  //         err_stack = err_stack.substr(0, 1024); //最大1024
  //       }
  //       err_name = err.name;
  //       err_msg = err.message;

  //     } else {
  //       err_msg = err
  //     }

  //     if (err_msg === "WeixinJSBridge is not defined") { //无影响，不做上报
  //       return;
  //     }
  //     const params = {};
  //     window.gact = window.gact || {};
  //     params.uuid = window.$bus.user.uuid || 'unknow';
  //     params.act_name = window.rootdata.act_name_chn;
  //     params.source = window.gact.source;
  //     params.uvip = window.$bus.user.vip_id;
  //     params.cookie = window.gact.analysis_id;
  //     params.mac = window.$bus.device_info.mac || "";
  //     params.debug = window.gact.debug;
  //     params.invoker = window.gact.invoker;
  //     params.user_type = window.$bus.user.user_type;
  //     params.app_version = window.$bus.device_info.appVersion;
  //     params.ticket = window.$bus.user.ticket;
  //     params.time = yyyyMMddhhmmss();
  //     params.type = 'error_v2';
  //     params.err_name = err_name;
  //     params.err_type = error_type;
  //     params.err_msg = err_msg;
  //     params.err_stack = err_stack;

  //     let bus = {};
  //     if (window.$bus) {
  //       bus = Object.assign({}, window.$bus.$data)
  //       if (bus.rootdata) {
  //         delete bus.rootdata
  //       }
  //     }
  //     let gact = {}
  //     if (window.gact) {
  //       gact = Object.assign({}, window.gact)
  //       if (gact.config) {
  //         delete gact.config
  //       }
  //     }
  //     params.metadata = {

  //     }

  //     if (isObject(data)) {
  //       params.metadata = Object.assign({}, params.metadata, data);
  //     } else if (isString(data)) {
  //       params.metadata = Object.assign({}, params.metadata, { tips: data });
  //     }
  //     params.metadata = JSON.stringify(params.metadata)
  //     // _param = Object.assign({}, params, {func: data});

  //     console.debug(params)

  //     axios.get("//vip.log.mgtv.com/vipact_event.html" + '?' + queryString.stringify(params)).catch(e => {
  //       console.debug(e.message)
  //     }) //防止引发上报死循环
  //   } catch (e) {
  //     console.error(e.message)
  //   }
  // }, 0);
}

function pad2(n) {
  return n < 10 ? '0' + n : n
}

function yyyyMMddhhmmss() {
  const date = new Date();
  return date.getFullYear().toString() + pad2(date.getMonth() + 1) + pad2(date.getDate()) + pad2(date.getHours()) + pad2(date.getMinutes()) + pad2(date.getSeconds())
}

import axios from 'axios'

export function click_event(event_name,award_id) {
  setTimeout(() => {
    const params = {};
    params.uuid = window.$bus.user.uuid || 'unknow';
    params.time = yyyyMMddhhmmss();
    params.act_name = window.rootdata.act_name_chn;
    params.source = window.gact.source;
    params.uvip = window.$bus.user.vip_id
    params.cookie = window.gact.analysis_id;
    params.type = 'event';
    params.info = event_name;
    params.mac = window.$bus.device_info.mac || ""
    params.debug = window.gact.debug;
    params.invoker = window.gact.invoker;
    params.user_type = window.$bus.user.user_type
    params.app_version = window.$bus.device_info.appVersion
    params.ticket = window.$bus.user.ticket
    params.refer = window.document.referrer || "";
    // 算法智能推荐需要该字段
    if(award_id) {
      params.award_id = award_id,
      params.event_type = 'success',
      params.sob = get_param('sob')
    }
    // axios.get().catch(e => {
    // })
    report("//vip.log.mgtv.com/vipact_event.html" + '?' + queryString.stringify(params))
  }, 0);
}


export function page_view(page_name) {
  setTimeout(() => {
    const params = {};
    params.uuid = window.$bus.user.uuid || 'unknow';
    params.time = yyyyMMddhhmmss();
    params.act_name = window.rootdata.act_name_chn;
    params.source = window.gact.source;
    params.uvip = window.$bus.user.vip_id;
    params.cookie = window.gact.analysis_id;
    params.type = 'pv';
    params.info = page_name;
    params.mac = window.$bus.device_info.mac || ""
    params.debug = window.gact.debug;
    params.invoker = window.gact.invoker;
    params.user_type = window.$bus.user.user_type
    params.app_version = window.$bus.device_info.appVersion
    params.ticket = window.$bus.user.ticket;
    params.refer = window.document.referrer || "";
    // axios.get("//vip.log.mgtv.com/vipact_event.html" + '?' + queryString.stringify(params)).catch(e => {
    // })
    report("//vip.log.mgtv.com/vipact_event.html" + '?' + queryString.stringify(params))

  }, 0);

  if (window.Bulma) {
    window.Bulma.log('pv', { istc: "mem", ac: window.gact.source, uuid: window.$bus.user.uuid, uvip: window.$bus.user.uvip });
  }

  click_event(page_name)
  web_sdk_pv();
}

/**
 * PV上报
 */
export function web_sdk_pv() {
  if (window.MgStat) {
    window.MgStat.send('pv', {
      cid: get_param('cid') || window.$bus.tpl.tpl_page.cid || '9100',
      cpid: get_param('cpid') || window.$bus.tpl.tpl_page.cpid || '1480',
    }, {
      cntp: `vip_${window.rootdata.act_name}`
    })
  }
}



/**
 * app收银台pv上报
 */
function appCasherPV(clocation) {
  const device_info = window.$bus.device_info;
  const params = {
    act: 'vip',
    pagename: 'ACT_D',
    actid: gact.source,
    clocation: clocation,
    uuid: window.$bus.user.uuid,
    time: yyyyMMddhhmmss(),
    mod: device_info.mod,
    ch: device_info.ch,
    sver: device_info.sver,
    gps: device_info.gps,
    mf: device_info.mf,
    did: device_info.did,
    cid: device_info.cid,
    bid: '2.1.1',
    net: device_info.net,
    pver: device_info.pver,
    pix: device_info.pix,
    aver: device_info.aver
  };
  // setTimeout(() => {
  //   axios.get("//vip.log.mgtv.com/audit_mpp.html" + '?' + queryString.stringify(params)).catch(e => {
  //   })
  // }, 0);
  report("//vip.log.mgtv.com/audit_all.html" + '?' + queryString.stringify(params))
}

/**
 * h5收银台pv上报
 */
function h5CasherPV(clocation) {
  const params = {
    bid: '5.1.1',
    time: yyyyMMddhhmmss(),
    pagename: 'ACT_D',
    unid: gact.source,
    uuid: window.$bus.user.uuid,
    act: 'vip',
    ftype: 5,
    clocation: clocation,
    actid: gact.source,
    thirdid: 'other'
  };
  // setTimeout(() => {
  //   axios.get("//vip.log.mgtv.com/audit_all.html" + '?' + queryString.stringify(params)).catch(e => {
  //   })
  // }, 0);
  report("//vip.log.mgtv.com/audit_all.html" + '?' + queryString.stringify(params))

}

/**
 *
 * @param {*} clocation 页面不同入口
 * @param {*} productId 产品编号
 * @param {*} price  产品价格
 * @param {*} channel_id 渠道uuid
 * @param {*} order 订单号
 */
function appOrder(clocation, productId, price, channel_id, order) {
  const device_info = window.$bus.device_info;
  const params = {
    pagename: 'Q',
    actid: gact.source,
    uuid: window.$bus.user.uuid,
    time: yyyyMMddhhmmss(),
    mod: device_info.mod,
    ch: device_info.ch,
    sver: device_info.sver,
    gps: device_info.gps,
    mf: device_info.mf,
    did: device_info.did,
    cid: device_info.cid,
    bid: '2.1.1',
    net: device_info.net,
    pver: device_info.pver,
    pix: device_info.pix,
    aver: device_info.aver,
    p: productId,
    pp: price,
    c: channel_id,
    o: order,
    act: 'order',
    isad: 0,
    mcc: 0,
    clocation: clocation,
    source: 'ACT_D',
    loginflag: 0,
    expver: "0"
  };
  // setTimeout(() => {
  //   axios.get("//vip.log.mgtv.com/audit_mpp.html" + '?' + queryString.stringify(params)).catch(e => {
  //   })
  // }, 0);
  report("//vip.log.mgtv.com/audit_all.html" + '?' + queryString.stringify(params))

}


/**
 *
 * @param {*} clocation 页面不同入口
 * @param {*} productId 产品编号
 * @param {*} price  产品价格
 * @param {*} channel_id 渠道uuid
 * @param {*} order 订单号
 */
function h5Order(clocation, productId, price, channel_id, order) {
  const params = {
    bid: '5.1.1',
    time: yyyyMMddhhmmss(),
    pagename: 'ACT_D',
    unid: gact.source,
    ftype: 5,
    clocation: clocation,
    uuid: window.$bus.user.uuid,
    act: 'order',
    p: productId,
    pp: price,
    c: channel_id,
    o: order,
    sysport: gact.is_ott ? 1 : 2,
    thirdid: 'other',
    actid: gact.source
  };
  // setTimeout(() => {
  //   axios.get("//vip.log.mgtv.com/audit_all.html" + '?' + queryString.stringify(params)).catch(e => {
  //   })
  // }, 0);
  report("//vip.log.mgtv.com/audit_all.html" + '?' + queryString.stringify(params))
}


export function orderEvent(clocation, productId, price, channel_id, order) {
  if (gact.is_app) {
    if (gact.is_android) {
      if (compare_version('>', '5.7.3')) {
        appOrder(clocation, productId, price, channel_id, order)
      }
    } else {
      appOrder(clocation, productId, price, channel_id, order)
    }
  } else {
    h5Order(clocation, productId, price, channel_id, order)
  }
}

export function casherPV(clocation) {
  if (gact.is_app) {
    appCasherPV(clocation)
  } else {
    h5CasherPV(clocation)
  }
}



function beacon_report(url) {
  if (!navigator.sendBeacon) {
    return false;
  }
  //判断支不支持navigator.sendBeacon
  return navigator.sendBeacon(url);
}

function img_report(url) {
  let img = new Image();
  img.onload = img.onerror = function () {
    img = null;
  };
  img.src = url;
}

function axios_report(url) {
  axios.get(url).catch(e => { });
}


export function report(url) {
  setTimeout(() => {
    if (navigator.sendBeacon) { //浏览器需要支持navigator.sendBeacon, 微信浏览器中好像有bug
      beacon_report(url)
    } else if (url.length < 2083) { //img不能使用太长的url
      img_report(url);
    }
    else {
       axios_report(url); //同步发送 最不推荐，兜底用
    }
  }, 0);
}

export function report_urls(url_list) {
  if (!isArray(url_list)) {
    return;
  }
  url_list.forEach(url => {
    report(url);
  })
}
